module.exports = __webpack_public_path__ + "img/spoken_arrow_r.c95c5ad1.svg";